<template>
  <div class="h-100">
    <div v-if="initial_loaded && !error_message" class="h-100 d-flex flex-column flex-nowrap">
      <header class="flex-shrink-0 header" :style="header_footer_style">
        <a :href="blog.url" class="text-center text-light" target="_blank">
          <div class="py-2 h3 text-light header__title">
            <b>{{ blog.title }}</b>
          </div>
        </a>
        <div class="col text-center text-light my-3" v-if="show_description_bool && blog.description">
          {{ blog.description }}
        </div>
      </header>

      <div class="overflow-auto flex-grow-1 tumblr-embed__content"
            :style="background_style"
             @scroll="infiniteScroll">
          <div class="container">
              <TumblrPost v-for="post in posts"
                          :key="post.id"
                          :post="post"
                          :show_notes="show_notes_bool"
                          :show_tags="show_tags_bool">
              </TumblrPost>
              <div class="row my-4">
                <div class="col text-center">
                  <font-awesome-icon icon="spinner"
                                      size="2x"
                                      class="spinning text-light"
                                      v-if="loading"/>
                </div>
             </div>
          </div>
      </div>


      <footer class="flex-shrink-0" :style="header_footer_style">
        <div class="col text-center py-2">
          <a target="_blank" :href="tumblr_widget_url" class="text-light">
            Embedded with <span class="font-weight-bold">Tumblr Widget</span>
          </a>
        </div>
      </footer>
    </div>
    <div class="d-flex justify-content-center align-items-center h-100" v-else>
      <font-awesome-icon icon="spinner" size="2x" class="spinning" />
    </div>
  </div>
</template>


<script>
import TumblrPost from '@/components/TumblrPost.vue';

const tumblr = require('tumblr.js');

const tumblrClient = tumblr.createClient({
  credentials: {
    consumer_key: process.env.VUE_APP_TUMBLR_KEY,
  },
  returnPromises: true,
});

export default {
  name: 'TumblrEmbed',
  components: {
    TumblrPost,
  },
  data() {
    return {
      blog: {},
      posts: [],
      total_posts: 0,
      initial_loaded: false,
      loading: false,
      error_message: '',
      posts_offset: 0,
      posts_limit: 20,
      tumblr_widget_url: process.env.VUE_APP_BASE_URL,
    };
  },
  props: {
    blog_name: {
      type: String,
      required: true,
    },
    show_description: {
      type: String,
      default: 'false',
    },
    background_color: {
      type: String,
      default: 'FFFFFF',
    },
    header_footer_color: {
      type: String,
      default: 'FFFFFF',
    },
    border_style: {
      type: String,
      default: 'square',
    },
    show_notes: {
      type: String,
      default: 'true',
    },
    show_tags: {
      type: String,
      default: 'true',
    },
  },
  mounted() {
    this.loadPosts();
  },
  computed: {
    all_posts_loaded() {
      return this.posts.length === this.total_posts;
    },
    header_footer_style() {
      return {
        'background-color': `#${this.header_footer_color}`,
      };
    },
    background_style() {
      return {
        'background-color': `#${this.background_color}`,
      };
    },
    show_description_bool() {
      return String(this.show_description) === 'true';
    },
    show_notes_bool() {
      return String(this.show_notes) === 'true';
    },
    show_tags_bool() {
      return String(this.show_tags) === 'true';
    },
  },
  methods: {
    loadPosts() {
      this.loading = true;
      tumblrClient.blogPosts(this.blog_name, {
        offset: this.posts_offset,
        limit: this.posts_limit,
      })
        .then((data) => {
          if (!this.initial_loaded) {
            this.blog = data.blog;
            this.total_posts = data.total_posts;
            this.initial_loaded = true;
          }

          this.posts.push(...data.posts);
          this.posts_offset = this.posts_offset + this.posts_limit;
          this.loading = false;
        })
        .catch((error) => {
          this.error_message = error;
        });
    },
    infiniteScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight && !this.loading && !this.all_posts_loaded) {
        this.loadPosts();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  &__title {
    line-height: inherit;
    margin-bottom: inherit;
  }
}
.spinning {
  animation: spinner 2s linear infinite;
}

@keyframes spinner {
  to { transform: rotate(360deg); }
}
</style>
